import DiscountApi from '@apis/discount/DiscountApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const DISCOUNTS_STALE_TIME = 100000;

const discountKeys = createQueryKeys('discounts', {
    list: (shopId: string) => ({
        queryKey: ['list', shopId],
        queryFn: () => DiscountApi.getDiscounts(shopId),
    }),
    prepaidCards: (shopId: string) => ({
        queryKey: [shopId, 'prepaidCards'],
        queryFn: () => DiscountApi.getDiscountPrepaidCards(shopId),
    }),
});

const discountQueries = {
    ...discountKeys,
    list: (shopId: string) => ({
        ...discountKeys.list(shopId),
        staleTime: DISCOUNTS_STALE_TIME,
    }),
    prepaidCards: (shopId: string) => ({
        ...discountKeys.prepaidCards(shopId),
        staleTime: DISCOUNTS_STALE_TIME,
    }),
};

export default discountQueries;
